package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

@Serializable
@JvmInline
@Stable
value class LanguageCode(val code: String)